module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/icon_prev-9719adc20042c42bb59b7ce047f690c5.svg";